import { useState } from "react";
import Alert from "@mui/material/Alert";
import { useViewport } from "../../utils/useViewport";

const STORAGE_PREFIX = "thrive.largeScreenNotice.";

// Storage can be missing or throw (private mode, blocked site data): the
// notice then simply shows again on the next visit.
const isDismissed = (pageKey: string) => {
  try {
    return localStorage.getItem(STORAGE_PREFIX + pageKey) === "1";
  } catch {
    return false;
  }
};

const rememberDismissed = (pageKey: string) => {
  try {
    localStorage.setItem(STORAGE_PREFIX + pageKey, "1");
  } catch {
    // Not remembered; dismissed for this page view only.
  }
};

interface LargeScreenNoticeProps {
  // One key per page: dismissing the notice hides it on that page only.
  pageKey: string;
  message?: string;
}

// Phones only: a dismissible hint at the top of pages that are laid out for
// tablets and computers.
const LargeScreenNotice = ({
  pageKey,
  message = "This page works best on a tablet or computer.",
}: LargeScreenNoticeProps) => {
  const { isPhone } = useViewport();
  const [dismissed, setDismissed] = useState(() => isDismissed(pageKey));

  if (!isPhone || dismissed) {
    return null;
  }

  const dismiss = () => {
    setDismissed(true);
    rememberDismissed(pageKey);
  };

  return (
    <Alert severity="info" onClose={dismiss} sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
};

export default LargeScreenNotice;
